import { render, staticRenderFns } from "./IndustrySlider.vue?vue&type=template&id=1cc97710&scoped=true&"
import script from "./IndustrySlider.vue?vue&type=script&lang=js&"
export * from "./IndustrySlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc97710",
  null
  
)

export default component.exports